import { connect } from 'react-redux'
import MenuMobile from './MenuMobile'

const mapStateToProps = ({
  mainMenu: { tradeMenu },
  productCategories,
  stores,
  catalog: {
    currencyConfiguration: { pointsName }
  },
  balance,
  publicUser
}) => ({
  tradeMenu,
  productCategories,
  stores,
  pointsName,
  balance,
  publicUser
})

export default connect(mapStateToProps)(MenuMobile)



// WEBPACK FOOTER //
// ./src/App/MainMenu/MenuMobile/MenuMobilePublicContainer.js